"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCompanyAppSmsConfig = getCompanyAppSmsConfig;
exports.saveCompanyAppSmsConfig = saveCompanyAppSmsConfig;
exports.testSmsSend = testSmsSend;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getCompanyAppSmsConfig(companyAppId) {
  return (0, _request.default)({
    url: "/admin/sms/config/app/".concat(companyAppId),
    method: 'get'
  });
}
function saveCompanyAppSmsConfig(companyAppId, config) {
  return (0, _request.default)({
    url: "/admin/sms/config/app/".concat(companyAppId),
    method: 'put',
    data: {
      config: config
    }
  });
}
function testSmsSend(data) {
  return (0, _request.default)({
    url: '/admin/sms/config/test',
    method: 'post',
    data: data
  });
}